import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';

import { StorageService } from './storage.service';

import { User } from '../interfaces/user';

import { environment } from 'src/environments/environment';
import { Plan } from '../interfaces/plan';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  USER_URL = environment.apiUrl + '/user';
  apiUrl = environment.apiUrl;

  userExperienceLevels: any = [
    {
      name: 'Acondicionamiento Físico (0 - 6 meses)',
      level: 0,
      tabletLevel: 5,
    },
    {
      name: 'Novato (6 meses - 1 año y medio)',
      level: 1,
      tabletLevel: 17,
    },
    {
      name: 'Principiante (1año y medio - 3 años)',
      level: 2,
      tabletLevel: 35,
    },
    {
      name: 'Intermedio (3 años - 6 años)',
      level: 3,
      tabletLevel: 71,
    },
    {
      name: 'Avanzado (+6 años)',
      level: 4,
      tabletLevel: 73,
    },
  ];

  constructor(
    private http: HttpClient,
    private storageService: StorageService
  ) {}

  getAllUsers(): Observable<User[]> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.get<User[]>(this.USER_URL + '/all', {
      headers: httpHeaders,
    });
  }

  filterUsers(filterString: string): Observable<User[]> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.get<User[]>(`${this.USER_URL}/all?${filterString}`, {
      headers: httpHeaders,
    });
  }

  getUserForm(userId: number, formType: string) {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.get(
      `${this.USER_URL}/${userId}/form-responses/${formType}`,
      {
        headers: httpHeaders,
      }
    );
  }

  getPlans(): Observable<Plan[]> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.get<Plan[]>(`${this.apiUrl}/plan`, {
      headers: httpHeaders,
    });
  }

  createPlan(planData: {
    userId: number;
    planId: number;
    weeks: number;
  }): Observable<null> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.post<null>(
      `${this.apiUrl}/user-plan`,
      { ...planData },
      { headers: httpHeaders }
    );
  }

  finishPlan(planId: number): Observable<null> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.post<null>(
      `${this.apiUrl}/user-plan/${planId}/finish`,
      {},
      {
        headers: httpHeaders,
      }
    );
  }

  changeRole(roleData: { userId: number; role: string }): Observable<null> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.patch<null>(
      `${this.apiUrl}/change-role`,
      {
        ...roleData,
      },
      {
        headers: httpHeaders,
      }
    );
  }

  getLatestTermsAndConditions(): Observable<any> {
    return this.http.get(
      `${environment.baseUrlMobile}/terms-and-conditions/latest`
    );
  }

  getLatestPrivacyPolicy(): Observable<any> {
    return this.http.get(`${environment.baseUrlMobile}/privacy-policy/latest`);
  }
}
